// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1rvEp","loaderOuter":"PageOverlayLoader_loaderOuter__24mvE"};